const isNumber = (maybeNumber: any): maybeNumber is number =>
  typeof maybeNumber === 'number' &&
  !Number.isNaN(maybeNumber)

export default isNumber
